import ru from '../../common/ru';

const lang: Record<string, string> = {
    ...ru,
};

export default lang;
